import { useState, useRef, useEffect } from "react";
import { ToolsShell, SensorNotice, primaryBtn, TOOLS_ACCENT } from "./ToolsShell.jsx";

// iOS exposes true heading via e.webkitCompassHeading. Others use
// alpha (0=N, increasing counter-clockwise → convert to clockwise).
export default function Compass() {
  const [state, setState] = useState("idle");
  const [heading, setHeading] = useState(0);
  const handler = useRef(null);

  const enable = async () => {
    if (typeof DeviceOrientationEvent === "undefined") { setState("unsupported"); return; }
    try {
      if (typeof DeviceOrientationEvent.requestPermission === "function") {
        const res = await DeviceOrientationEvent.requestPermission();
        if (res !== "granted") { setState("denied"); return; }
      }
      handler.current = (e) => {
        let h;
        if (typeof e.webkitCompassHeading === "number") h = e.webkitCompassHeading;
        else if (typeof e.alpha === "number") h = (360 - e.alpha) % 360;
        else return;
        setHeading(h);
      };
      window.addEventListener("deviceorientation", handler.current, true);
      setState("ok");
    } catch {
      setState("denied");
    }
  };

  useEffect(() => () => {
    if (handler.current) window.removeEventListener("deviceorientation", handler.current, true);
  }, []);

  const dir = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"][Math.round(heading / 45) % 8];

  return (
    <ToolsShell title="Compass">
      {state !== "ok" && (
        <div style={{ textAlign: "center", marginTop: 20 }}>
          <button onClick={enable} style={primaryBtn}>Enable compass</button>
          <SensorNotice state={state === "idle" ? "prompt" : state} what="Orientation sensor" />
        </div>
      )}
      {state === "ok" && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: 24 }}>
          <div style={{ position: "relative", width: 240, height: 240 }}>
            <div style={{ position: "absolute", inset: 0, borderRadius: "50%", border: "2px solid #262839", transform: `rotate(${-heading}deg)`, transition: "transform 0.1s linear" }}>
              {["N", "E", "S", "W"].map((c, i) => (
                <div key={c} style={{ position: "absolute", left: "50%", top: 8, transform: `translateX(-50%) rotate(${i * 90}deg)`, transformOrigin: "50% 112px", fontSize: 18, fontWeight: 700, color: c === "N" ? TOOLS_ACCENT : "#9A9DBE" }}>
                  {c}
                </div>
              ))}
            </div>
            <div style={{ position: "absolute", left: "50%", top: "50%", width: 0, height: 0, transform: "translate(-50%,-50%)", borderLeft: "10px solid transparent", borderRight: "10px solid transparent", borderBottom: `90px solid ${TOOLS_ACCENT}`, transformOrigin: "50% 100%", marginTop: -45 }} />
          </div>
          <div style={{ marginTop: 28, fontSize: 30, fontWeight: 700, color: TOOLS_ACCENT }}>
            {Math.round(heading)}° {dir}
          </div>
          <p style={{ fontSize: 12, color: "#5B5E7A", marginTop: 10, textAlign: "center", maxWidth: 280 }}>
            Magnetic heading. Accuracy depends on device calibration — move in a figure-8 if it drifts.
          </p>
        </div>
      )}
    </ToolsShell>
  );
}

